<template>
  <div>
    <form @submit.prevent="submitChanges">
    <div class="panel-heading" style="display: flex; align-items: center; justify-content: space-between;">
      <h4 class="panel-title" style="margin: 0;">Subscription</h4>
      <div class="col-md-12">
        <div class="col-md-6"></div>
        <div class="col-md-6 text-right">
          <v-btn
          style="height: auto"
          depressed
          @click="openAddEditSubscriptionModal"
        >
          <v-icon
            v-if="$_has_perm('add_subscription')"
            icon
            style="color: #006b8d"
            class="fa fa-plus fa-lg mr-2"
          > </v-icon>
          Add New Subscription
        </v-btn>
        </div>
      </div>
    </div>

    <div
      class="panel-body"
      style="display: block;"
    >
      <div class="row">
        <div class="col-xs-12">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>Subscription Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in apiResults" :key="item.id || idx" :style="item.subscription_name.toLowerCase() === 'normal' ? 'background-color: #f5b767;' : ''">
                <td>{{ item.subscription_id }}</td>
                <td>{{ item.subscription_name }}</td>
                <td>
                  <a
                    v-if="$_has_perm('edit_subscription')"
                    style="color:#01579B"
                    tooltip="Edit Subscription"
                    @click="editRecord(item, idx)"
                  >
                    <i class="material-icons">edit</i>
                  </a>
                  <a
                    v-if="$_has_perm('delete_subscription')"
                    style="color: #B22708FF"
                    tooltip="Delete Subscription"
                    @click="deleteRecord(item, idx)"
                  >
                    <i class="material-icons">delete</i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    </form>

    <add-edit-subscription
      :addEditSubscriptionModal="addEditSubscriptionModal"
      :closeAddEditSubscriptionModal="closeAddEditSubscriptionModal"
      :submitAddEditSubscription="submitAddEditSubscription"
      :addEditData="addEditData"
      ></add-edit-subscription>

  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import addEditSubscription from './addEditSubscription.vue'

export default {
  components: {
    'add-edit-subscription': addEditSubscription
  },
  mounted() {
    this.getResults()
  },
  $_veeValidate: {
    validator: 'new'
  },
  data() {
    return {
      loading: false,
      addEditSubscriptionModal: false,
      url: 'api/subscriptions',
      apiResults: [],
      warehouses: [],
      addEditData: {
        subscription_name: ''
      }
    }
  },

  methods: {

    getResults(url = this.url) {
      let token = localStorage.getItem('access_token')

      axios
        .get(url, { params: this.tableData, headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          let data = response.data
          this.apiResults = data.data
        })
    },

    openAddEditSubscriptionModal() {
      this.addEditSubscriptionModal = true
    },

    closeAddEditSubscriptionModal() {
      this.addEditSubscriptionModal = false
      this.clear()
    },

    clear() {
      this.addEditData = {
        subscription_name: ''
      }
      this.addEditSubscriptionModal = false
      this.$validator.reset()
    },

    submitAddEditSubscription() {
      let token = localStorage.getItem('access_token')

      const isEditing = this.addEditData.subscription_id
      const method = isEditing ? 'patch' : 'post'
      const url = isEditing ? `${this.url}/${this.addEditData.subscription_id}` : this.url

      axios[method](url, this.addEditData, { headers: { Authorization: 'Bearer ' + token } })
        .then(response => {
          this.validationError = false
          this.checkAlert = true
          this.getResults()
          this.clear()
        })
        .catch(error => {
          if (error.response.data.message) {
            this.checkAlert = false
            this.validationError = true
          }
        })
    },

    editRecord(item, idx) {
      this.addEditData = {
        subscription_id: item.subscription_id,
        subscription_name: item.subscription_name
      }
      this.addEditSubscriptionModal = true
      this.$validator.reset()
    },

    deleteRecord(item, idx) {
      swal({
        title: 'Are you sure?',
        text: `Delete subscription: ${item.subscription_name}?`,
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((willDelete) => {
        if (willDelete) {
          let token = localStorage.getItem('access_token')
          axios
            .delete(this.url + '/' + item.subscription_id, { headers: { Authorization: 'Bearer ' + token } })
            .then(response => {
              this.getResults()
              swal({
                title: 'Done',
                text: '',
                icon: 'success',
                timer: 1500,
                buttons: false
              })
            })
            .catch(error => {
              if (error.response) {
                swal('Error', `${error.response.data.message}`, 'error')
              }
            })
        }
      })
    }
  }
}
</script>

<style>

/* Make the table dense */
.table.table-bordered th,
.table.table-bordered td {
  padding: 2px 4px !important;
  font-size: 13px !important;
  vertical-align: middle !important;
}

.table.table-bordered input.form-control {
  height: 20px !important;
  padding: 2px 6px !important;
  font-size: 13px !important;
}

.table.table-bordered {
  margin-bottom: 0;
}

.btn.btn-sm, .btn.btn-danger.btn-sm {
  padding: 2px 8px !important;
  font-size: 12px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/subscription/subscription.vue